module.exports = __webpack_public_path__ + "static/media/black.66cf39dd.jpg";